var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1971 4C30.5118 4 26.1176 7.76006 24 9.88806C21.8824 7.76006 17.4882 4 12.8029 4C4.79118 4 0 8.76996 0 16.759C0 23.3053 5.89412 28.7785 6.10588 28.9679L22.6059 45.2705C23.3824 46.037 24.6176 46.037 25.3941 45.2705L41.8676 29.022C42.1059 28.7785 48 23.2962 48 16.759C48 8.76996 43.2088 4 35.1971 4Z"
  })));
};
export default SvgHeart;